export default __webpack_public_path__ + "static/binary-18191c28eff6ea818c6881219759e239.svg";